import { useState } from "react"

import { StatCard } from "@/components/ui/stat-card"

export function StatCardPreviewRoute(): JSX.Element {
  const [selected, setSelected] = useState(false)

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">StatCard</h1>
      </header>

      <Section title="Inert (summary)">
        <div className="w-52">
          <StatCard value={128} label="Reviews sent" tone="master" />
        </div>
      </Section>

      <Section title="Interactive (filter)">
        <div className="w-52">
          <StatCard
            value={12}
            label="Awaiting review"
            tone="print"
            onSelect={() => setSelected((s) => !s)}
            selected={selected}
          />
        </div>
      </Section>

      <Section title="Disabled (count zero)">
        <div className="w-52">
          <StatCard
            value={0}
            label="Escalated"
            tone="err"
            onSelect={() => undefined}
            disabled
          />
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
